var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loaded)?_c('LineChartJS',{attrs:{"data":_vm.chartData,"options":_vm.chartOptions}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }